import { FieldValidation } from "../../validation/protocols";
import { InvalidFieldError } from "../../validation/errors";
import { MinLengthError } from "../errors/min-length-error";

export class MinLengthValidation implements FieldValidation {
  constructor(readonly field: string, private readonly minLength: number) {}

  validate(input: Record<string, any>): Error | null {
    return input[this.field]?.length < this.minLength
      ? new MinLengthError(this.minLength.toString())
      : null;
  }
}
